import moment from 'moment';
import * as Yup from 'yup';

import {PHONE_NUMBER_REGEX} from '../../../utils/validation';

const eighteenYearsAgoDate = new Date();
eighteenYearsAgoDate.setFullYear(eighteenYearsAgoDate.getFullYear() - 18);

// Based on MFL  but done manually because doing
// Yup.SchemaOf<Address> seems to be a pain at least with the current
// version of Yup
export const AddressSchema = Yup.object({
  lines: Yup.array()
    .of(Yup.string().required().min(1))
    .compact()
    .min(1, 'At least one address line is required'),
  locality: Yup.string().min(2).required('Suburb is required'),
  administrative_area: Yup.string().required(),
  postal_code: Yup.string().required('Postcode is required'),
});

export const CreateAccountSchema = Yup.object({
  firstName: Yup.string().required('This is a required field').nullable(),
  lastName: Yup.string().required('This is a required field').nullable(),
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('This is a required field')
    .nullable(),
  dateOfBirth: Yup.date()
    .max(eighteenYearsAgoDate, 'You must be 18 or older to create an account')
    .typeError('Invalid date')
    .required('This is a required field')
    .test('is-valid-date', 'Invalid date', value =>
      moment(value, 'YYYY-MM-DD', true).isValid(),
    )
    .nullable(),
  phoneNumber: Yup.string()
    .required('This is a required field')
    .matches(PHONE_NUMBER_REGEX, 'Please enter a valid Australian phone number')
    .nullable(),
  billingAddress: AddressSchema.nullable().required(
    'A billing address is required',
  ),
  passwordValidationBypass: Yup.boolean(),
});

export const passwordRequired = Yup.object({
  password: Yup.string()
    .min(8, 'Must be 8 characters or longer')
    .nullable()
    .required('This is a required field'),
});

export const passwordOptional = Yup.object({
  password: Yup.string().min(8, 'Must be 8 characters or longer'),
});
